import { render, staticRenderFns } from "./BxKuncunModal__Style#Drawer.vue?vue&type=template&id=fdd3ca64&scoped=true&"
import script from "./BxKuncunModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BxKuncunModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BxKuncunModal__Style#Drawer.vue?vue&type=style&index=0&id=fdd3ca64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd3ca64",
  null
  
)

export default component.exports